(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kash-about-script"] && !Shopify.designMode) return;
  try {
    (() => {
  const rootSelector = '[data-kash-about]';

  const startVideos = (root) => {
    root.querySelectorAll('video[autoplay]').forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      const playback = video.play();
      if (playback && typeof playback.catch === 'function') playback.catch(() => {});
    });
  };

  const reveal = (root) => {
    const items = root.querySelectorAll('[data-kash-about-reveal]');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    items.forEach((item) => observer.observe(item));
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll(rootSelector).forEach((root) => {
      if (root.dataset.kashAboutReady === 'true') {
        startVideos(root);
        return;
      }
      root.dataset.kashAboutReady = 'true';
      startVideos(root);
      reveal(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  window.addEventListener('pageshow', () => initialize());
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) initialize();
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kash-home-header-glass"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.documentElement;
  const mobileQuery = window.matchMedia('(max-width: 768px)');
  const heightProperty = '--kash-mobile-header-visual-height';
  const topOpacityProperty = '--kash-mobile-header-top-opacity';
  const bottomOpacityProperty = '--kash-mobile-header-bottom-opacity';
  const blurProperty = '--kash-mobile-header-blur';
  const saturationProperty = '--kash-mobile-header-saturation';
  const shadowProperty = '--kash-mobile-header-shadow-opacity';
  const visualProperties = [
    topOpacityProperty,
    bottomOpacityProperty,
    blurProperty,
    saturationProperty,
    shadowProperty,
  ];

  let frameId = 0;

  const clearVisualProperties = () => {
    visualProperties.forEach((property) => root.style.removeProperty(property));
  };

  const getScrollTop = () => Math.max(
    0,
    window.scrollY || 0,
    document.documentElement.scrollTop || 0,
    document.body ? document.body.scrollTop || 0 : 0,
  );

  const updateHeader = () => {
    frameId = 0;

    const mobileHome = document.querySelector('.kash-mobile-home');
    const header = document.querySelector('.section-header .header-wrapper');

    if (!mobileQuery.matches || !mobileHome || !header) {
      root.style.removeProperty(heightProperty);
      clearVisualProperties();
      return;
    }

    const height = Math.ceil(header.getBoundingClientRect().height);
    if (height > 0) {
      root.style.setProperty(heightProperty, `${height}px`);
    }

    const fadeDistance = Math.max(120, Math.min(190, height * 1.2));
    const rawProgress = Math.min(1, getScrollTop() / fadeDistance);
    const progress = 1 - Math.pow(1 - rawProgress, 2);

    root.style.setProperty(topOpacityProperty, (progress * 0.76).toFixed(4));
    root.style.setProperty(bottomOpacityProperty, (progress * 0.64).toFixed(4));
    root.style.setProperty(blurProperty, `${(progress * 24).toFixed(2)}px`);
    root.style.setProperty(saturationProperty, (1 + progress * 0.25).toFixed(3));
    root.style.setProperty(shadowProperty, (progress * 0.18).toFixed(4));
  };

  const scheduleUpdate = () => {
    if (frameId) return;
    frameId = window.requestAnimationFrame(updateHeader);
  };

  const bindResizeObserver = () => {
    if (!('ResizeObserver' in window)) return;

    const header = document.querySelector('.section-header .header-wrapper');
    if (!header || window.__kashMobileHeaderObservedElementV2 === header) return;

    if (window.__kashMobileHeaderResizeObserverV2) {
      window.__kashMobileHeaderResizeObserverV2.disconnect();
    }

    window.__kashMobileHeaderObservedElementV2 = header;
    window.__kashMobileHeaderResizeObserverV2 = new ResizeObserver(scheduleUpdate);
    window.__kashMobileHeaderResizeObserverV2.observe(header);
  };

  const initialize = () => {
    bindResizeObserver();
    scheduleUpdate();
    window.requestAnimationFrame(scheduleUpdate);
  };

  if (!window.__kashMobileHeaderScrollGlassBoundV2) {
    window.__kashMobileHeaderScrollGlassBoundV2 = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    window.addEventListener('load', initialize, { once: true });
    window.addEventListener('pageshow', initialize);
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', initialize, { passive: true });
    mobileQuery.addEventListener?.('change', initialize);

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) initialize();
    });
    document.addEventListener('shopify:section:load', initialize);
    document.addEventListener('shopify:section:select', initialize);
  } else {
    initialize();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kash-landing-content-script"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '[data-kash-landing-content]';
  const trim = value => typeof value === 'string' ? value.trim() : '';
  const one = selector => document.querySelector(selector);
  const all = selector => Array.from(document.querySelectorAll(selector));
  const split = value => trim(value).split('|').map(trim).filter(Boolean);

  const content = () => {
    const nodes = all(selector);
    const node = nodes[nodes.length - 1];
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.warn('Kash landing content could not be parsed.', error);
      return null;
    }
  };

  const text = (element, value) => {
    if (!element) return;
    const next = trim(value);
    element.hidden = !next;
    element.textContent = next;
  };

  const decorated = (element, value) => {
    if (!element) return;
    const next = trim(value);
    const mark = element.firstElementChild?.tagName === 'SPAN' ? element.firstElementChild : null;
    element.hidden = !next;
    if (mark) element.replaceChildren(mark, document.createTextNode(next));
    else element.textContent = next;
  };

  const button = (element, value) => {
    if (!element) return;
    const next = trim(value);
    const icon = element.querySelector('svg');
    element.hidden = !next;
    if (!next) return;
    if (icon) element.replaceChildren(document.createTextNode(next), icon);
    else element.textContent = next;
  };

  const heading = (element, value, lineClass, emphasizeAfterFirst = false) => {
    if (!element) return;
    const values = split(value);
    element.hidden = values.length === 0;
    const line = item => {
      const span = document.createElement('span');
      if (lineClass) span.className = lineClass;
      span.textContent = item;
      return span;
    };
    const children = [];
    if (values.length) children.push(line(values[0]));
    if (values.length > 1) {
      if (emphasizeAfterFirst) {
        const strong = document.createElement('strong');
        strong.append(...values.slice(1).map(line));
        children.push(strong);
      } else {
        children.push(...values.slice(1).map(line));
      }
    }
    element.replaceChildren(...children);
    if (values.length) element.setAttribute('aria-label', values.join(' '));
  };

  const apply = () => {
    const c = content();
    if (!c) return false;

    decorated(one('.kash-home-hero__copy > .kash-kicker'), c.d_eyebrow);
    heading(one('#kash-home-title'), c.d_headline, 'kash-home-title__line', true);
    text(one('.kash-home-hero__dek'), c.d_body);
    button(one('.kash-home-hero__actions .kash-button--primary'), c.primary_label);
    button(one('.kash-home-hero__actions .kash-button--glass'), c.secondary_label);

    const dc = all('.kash-home-hero__capabilities a');
    [[c.d_cap1, c.d_cap1_sub], [c.d_cap2, c.d_cap2_sub], [c.d_cap3, c.d_cap3_sub]].forEach((values, index) => {
      text(dc[index]?.querySelector('strong'), values[0]);
      text(dc[index]?.querySelector('small'), values[1]);
    });

    text(one('.kash-home-hero__scroll span'), c.d_scroll);
    decorated(one('.kash-home-services-intro > .kash-kicker'), c.d_services_kicker);
    heading(one('#kash-services-title'), c.d_services_head, 'kash-home-services-title__line');
    text(one('.kash-home-services-intro__grid > p'), c.d_services_body);

    if (!one('[data-kash-mobile-editor-content]')) {
      decorated(one('.kash-mobile-home__kicker'), c.m_brand);
      text(one('.kash-mobile-home__label'), c.m_label);
      heading(one('#kash-mobile-home-title'), c.m_headline, 'kash-mobile-title__line', true);
      text(one('.kash-mobile-home__dek'), c.m_body);
      button(one('.kash-mobile-home__actions .kash-mobile-button--primary'), c.primary_label);
      button(one('.kash-mobile-home__actions .kash-mobile-button--glass'), c.secondary_label);

      const mc = all('.kash-mobile-home__capabilities a');
      [c.m_cap1, c.m_cap2, c.m_cap3].forEach((value, index) => text(mc[index], value));

      decorated(one('.kash-mobile-services-intro__kicker'), c.m_services_kicker);
      heading(one('#kash-mobile-services-title'), c.m_services_head);
      text(one('.kash-mobile-services-intro > p:last-child'), c.m_services_body);
    }

    return Boolean(one('.kash-desktop-home') && one('.kash-mobile-home'));
  };

  if (!window.__kashLandingContentBound) {
    window.__kashLandingContentBound = true;
    window.__kashApplyLandingContent = apply;
    const observer = new MutationObserver(() => {
      if (apply()) observer.disconnect();
    });
    if (!apply()) observer.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('DOMContentLoaded', apply, { once: true });
    document.addEventListener('shopify:section:load', apply);
    document.addEventListener('shopify:section:select', apply);
  } else {
    window.__kashApplyLandingContent = apply;
    apply();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kash-mobile-label-alignment"] && !Shopify.designMode) return;
  try {
    (() => {
  const placeBrandLabel = () => {
    document.querySelectorAll('.kash-mobile-home').forEach((home) => {
      const heading = home.querySelector('#kash-mobile-home-title');
      const brandLabel = home.querySelector('.kash-mobile-home__kicker');

      if (!heading || !brandLabel) return;
      if (heading.nextElementSibling === brandLabel) return;

      heading.insertAdjacentElement('afterend', brandLabel);
    });
  };

  if (window.__kashMobileBrandPlacementBound) {
    placeBrandLabel();
    return;
  }

  window.__kashMobileBrandPlacementBound = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeBrandLabel, { once: true });
  } else {
    placeBrandLabel();
  }

  document.addEventListener('shopify:section:load', placeBrandLabel);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kash-portfolio-interactions"] && !Shopify.designMode) return;
  try {
    (() => {
  const roots = new Map();

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-kash-portfolio]').forEach((root) => {
      if (roots.has(root)) return;
      root.dataset.kashPlaybackVersion = '20260909';
      const ambient = root.dataset.autoplayVideos === 'true';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const visible = new Set();
      const cards = [];
      let active = null;

      const release = (state) => {
        const video = state.video;
        if (!video) return;
        state.revision++;
        state.position = video.ended ? 0 : video.currentTime;
        video.pause();
        video.controls = false;
        state.card.classList.remove('is-playing');
        state.trigger.removeAttribute('aria-busy');
        if (active === state) active = null;
        if (state.template) {
          video.removeAttribute('src');
          video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
          video.load();
          video.remove();
          state.video = null;
        } else {
          video.muted = true;
          video.defaultMuted = true;
          video.loop = true;
        }
      };

      const mount = (state) => {
        if (state.video) return state.video;
        const video = state.template?.content.querySelector('video')?.cloneNode(true);
        if (!video) return null;
        state.template.after(video);
        state.video = video;
        if (state.position > 0) {
          video.addEventListener('loadedmetadata', () => {
            if (state.video === video && Number.isFinite(video.duration)) {
              video.currentTime = Math.min(state.position, Math.max(0, video.duration - 0.1));
            }
          }, { once: true });
        }
        video.addEventListener('ended', () => release(state));
        video.addEventListener('error', () => {
          if (state.video === video) release(state);
        });
        return video;
      };

      const play = (state, withSound) => {
        if (active && active !== state) release(active);
        const video = mount(state);
        if (!video) return;
        active = state;
        const revision = ++state.revision;
        video.playsInline = true;
        video.muted = !withSound;
        video.defaultMuted = !withSound;
        video.loop = !withSound;
        video.controls = withSound;
        if (withSound) state.trigger.setAttribute('aria-busy', 'true');
        const playback = video.play();
        Promise.resolve(playback).then(() => {
          if (state.revision !== revision || state.video !== video) return;
          state.trigger.removeAttribute('aria-busy');
          if (withSound) state.card.classList.add('is-playing');
          state.trigger.dataset.kashPlaybackState = 'playing';
        }).catch((error) => {
          state.trigger.dataset.kashPlaybackState = error.name || 'error';
          if (state.revision === revision && state.video === video) release(state);
        });
      };

      const resumeAmbient = () => {
        if (!ambient || document.hidden || reducedMotion.matches || active) return;
        const next = cards.find(state => visible.has(state.card));
        if (next) play(next, false);
      };

      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const state = cards.find(item => item.card === entry.target);
          if (!state) return;
          if (entry.isIntersecting) visible.add(state.card);
          else {
            visible.delete(state.card);
            release(state);
          }
        });
        resumeAmbient();
      }, { threshold: 0 }) : null;

      root.querySelectorAll('[data-kash-video-card]').forEach(card => {
        const trigger = card.querySelector('[data-kash-video-trigger]');
        const template = card.querySelector('[data-kash-video-template]');
        const video = card.querySelector('video');
        if (!trigger || (!template && !video)) return;
        const state = { card, trigger, template, video, position: 0, revision: 0 };
        cards.push(state);
        trigger.addEventListener('click', () => { trigger.dataset.kashPlaybackState = 'requested'; play(state, true); });
        if (video) {
          video.addEventListener('ended', () => { release(state); resumeAmbient(); });
          video.addEventListener('error', () => release(state));
        }
        observer?.observe(card);
      });

      const pause = () => cards.forEach(release);
      const visibility = () => document.hidden ? pause() : resumeAmbient();
      document.addEventListener('visibilitychange', visibility);
      window.addEventListener('pagehide', pause);
      window.addEventListener('pageshow', resumeAmbient);
      roots.set(root, () => {
        observer?.disconnect();
        pause();
        document.removeEventListener('visibilitychange', visibility);
        window.removeEventListener('pagehide', pause);
        window.removeEventListener('pageshow', resumeAmbient);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    roots.forEach((dispose, root) => {
      if (event.target.contains(root)) { dispose(); roots.delete(root); }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kash-portfolio-script"] && !Shopify.designMode) return;
  try {
    document.documentElement.classList.add('kash-portfolio-js');

(() => {
  const rootSelector = '[data-kash-portfolio]';
  const itemSelector = '[data-kash-portfolio-reveal], [data-kash-portfolio-unit], .video-project-card';

  const showImmediately = (items) => {
    items.forEach((item) => item.classList.add('is-visible'));
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll(rootSelector).forEach((root) => {
      const main = root.closest('#MainContent') || document.querySelector('#MainContent');
      if (!main) return;

      const items = Array.from(main.querySelectorAll(itemSelector));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        showImmediately(items);
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });

      items.forEach((item) => {
        if (item.classList.contains('is-visible') || item.dataset.kashPortfolioObserved === 'true') return;
        item.dataset.kashPortfolioObserved = 'true';
        observer.observe(item);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  window.addEventListener('pageshow', () => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kash-request-bridge"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.KashRequestBridge?.version === 2) return;
  const endpoint = 'https://kash-studio-manager.kashproductions4.chatgpt.site/api/public/requests';
  const deliveries = new WeakMap();
  const requestId = () => {
    if (crypto.randomUUID) return crypto.randomUUID();
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const value = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
    return `${value.slice(0, 8)}-${value.slice(8, 12)}-${value.slice(12, 16)}-${value.slice(16, 20)}-${value.slice(20)}`;
  };
  window.KashRequestBridge = {
    version: 2,
    async sendForm(form, payload) {
      const fingerprint = JSON.stringify(payload);
      let delivery = deliveries.get(form);
      if (!delivery || delivery.fingerprint !== fingerprint) {
        delivery = {fingerprint, id: requestId(), receipt: null};
        deliveries.set(form, delivery);
      }
      if (delivery.receipt) return delivery.receipt;
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(endpoint, {
          method: 'POST', mode: 'cors', credentials: 'omit',
          headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
          body: new URLSearchParams({...payload, id: delivery.id}).toString(),
          signal: controller.signal
        });
        const value = await response.json().catch(() => null);
        if (!response.ok || response.redirected || value?.ok !== true || value.id !== delivery.id) {
          throw new Error(value?.error || 'Your request has not been confirmed. Please try again.');
        }
        delivery.receipt = value;
        form.dataset.managerReceipt = value.id;
        return value;
      } finally {
        clearTimeout(timer);
      }
    },
    async prepareEmail(form) {
      if (form.dataset.hcaptchaBound || form.dataset.recaptchaBound || !window.Shopify?.captcha?.protect) return;
      await new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(new Error('Your request is saved. Please try again to finish the email confirmation.')), 15000);
        window.Shopify.captcha.protect(form, () => {clearTimeout(timer); resolve();});
      });
    }
  };
})();
  } catch(e) { console.error(e); }
})();

})();
